import axios from "axios";
import React, { useState } from "react";
import { Redirect } from "react-router";

const Form = () => {
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [vimeoUrl, setVimeoUrl] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    let data = new FormData();
    data.append("title", title);
    data.append("text", text);
    data.append("vimeo_url", vimeoUrl);

    setLoading(true);

    axios
      .post("alarm/proanalysis/create/", data)
      .then((res) => setSuccess(true))
      .catch((e) => alert("Kaydedilirken bir hata oluştu."))
      .finally(() => setLoading(false));
  };

  if (success) return <Redirect to="/proanalysis" />;

  return (
    <div>
      <div className="mb-4">
        <label>Başlık</label>
        <input
          required
          type="text"
          className="form-input w-full"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <label>Vimeo Adresi</label>
        <input
          required
          type="text"
          className="form-input w-full"
          value={vimeoUrl}
          onChange={(e) => setVimeoUrl(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <label>İçerik</label>
        <textarea
          required
          className="form-textarea w-full h-64"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading}
        className="rounded bg-blue-600 text-white py-1 px-4 mt-4"
      >
        {loading ? "Kaydediliyor..." : "Kaydet"}
      </button>
    </div>
  );
};

const ProAnalysisCreate = () => {
  return (
    <div>
      <div className="mb-4 pt-1.5 flex items-center">
        <div className="font-bold text-xl flex-grow">Analiz PRO Yeni Kayıt</div>
      </div>

      <div className="bg-white rounded-md shadow-md p-4 mb-4">
        <Form />
      </div>
    </div>
  );
};

export default ProAnalysisCreate;
